import type { LoaderFunctionArgs } from 'react-router';
import { generateRegistrationDataByCodeQueryOptions } from '@/hooks/scan-code/use-registration-data-by-code';
import ROUTES from '@/routes';
import { catchFetcherError } from '@/utils/fetcher';
import { queryClient } from '@/utils/query-client';

export function contactRequestInviteLoader({ request }: LoaderFunctionArgs) {
  const { searchParams } = new URL(request.url);
  const { code } = ROUTES.CONTACT.REQUEST.INVITE.$deserializeSearchParams(searchParams);

  return {
    promises: queryClient.prefetchQuery(generateRegistrationDataByCodeQueryOptions(code)).catch(catchFetcherError),
  };
}
